import React from 'react';
import TabItem from '../../../../../moderation-v2/comments-and-posts/dashboard/header/folder-button';
import { LiveBlogFilter, LiveBlogSorting } from '../../../state/types';
import SortByFilter from './SortByFilter';

interface Props {
  timeFilter: LiveBlogFilter;
  sortBy: LiveBlogSorting;
  count: number;
  onTimeFilterChange: (timeFilter: LiveBlogFilter) => void;
  onSortingChange: (sortBy: LiveBlogSorting) => void;
  onCreate: () => void;
}

const EventListHeader: React.FC<Props> = ({
  timeFilter,
  sortBy,
  count = 0,
  onTimeFilterChange,
  onSortingChange,
  onCreate
}) => {
  const onTabItemClick = (timeFilter: LiveBlogFilter) => {
    return () => onTimeFilterChange(timeFilter);
  };

  const onCreateNewLiveBlogClick = () => {
    onCreate();
  };

  return (
    <>
      <div className={'live-events-title-container'}>
        <h4>Events</h4>
        <button className="create-button" onClick={onCreateNewLiveBlogClick}>
          Create Event
        </button>
      </div>
      <div className="filter-container">
        <div className="dashboard-filter">
          <TabItem
            label={'Live'}
            onClick={onTabItemClick(LiveBlogFilter.Live)}
            isActive={timeFilter === LiveBlogFilter.Live}
            count={count}
          />
          <TabItem
            label={'Upcoming'}
            onClick={onTabItemClick(LiveBlogFilter.Upcoming)}
            isActive={timeFilter === LiveBlogFilter.Upcoming}
            count={count}
          />

          <TabItem
            label={'Past'}
            onClick={onTabItemClick(LiveBlogFilter.Past)}
            isActive={timeFilter === LiveBlogFilter.Past}
            count={count}
          />
          <TabItem
            label={'All'}
            onClick={onTabItemClick(LiveBlogFilter.All)}
            isActive={timeFilter === LiveBlogFilter.All}
            count={count}
          />
          <SortByFilter sortBy={sortBy} onChange={onSortingChange} />
        </div>
      </div>
    </>
  );
};

export default EventListHeader;
